import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

export default function QuemSomos() {
  return (
    <div className="h-screen flex flex-col">
      <div className="bg-blue-500 sticky top-0">
        <NavBar />
      </div>
      <div className="w-full max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg font-questrial text-wrap break-words">
        <h1 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
          Quem Somos - Eyazs Imperium
        </h1>
        <p className="text-gray-700 text-sm md:text-lg lg:text-lg lg:w-auto mb-4 leading-relaxed w-auto">
          A <strong className="break-words">Eyazs Imperium</strong> é uma
          empresa moçambicana especializada em soluções de internet via fibra
          ótica, comprometida em transformar a forma como nossos clientes se
          conectam com o mundo. Fundada com o objetivo de levar tecnologia de
          ponta para todas as regiões de Moçambique, oferecemos serviços de
          alta qualidade, garantindo conexões rápidas, estáveis e seguras.
        </p>
        <p className="text-gray-700 text-sm md:text-lg lg:text-lg mb-4 w-auto leading-relaxed">
          Nosso propósito é simplificar a vida das pessoas e impulsionar o
          crescimento das empresas, fornecendo acesso confiável à internet,
          com foco na inovação e no atendimento personalizado. Acreditamos que
          uma conexão sólida é a base para o desenvolvimento, seja no ambiente
          familiar, empresarial ou educacional.
        </p>

        <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
          O Que Nos Define
        </h2>
        <ul className="list-disc list-inside text-gray-700 text-sm md:text-lg mb-4 leading-relaxed">
          <li>
            <strong>Velocidade e Confiabilidade:</strong> Utilizamos
            tecnologia de fibra ótica para oferecer internet com desempenho
            excepcional.
          </li>
          <li>
            <strong>Compromisso Local:</strong> Somos uma empresa moçambicana
            dedicada a contribuir para o desenvolvimento digital do país.
          </li>
          <li>
            <strong>Atendimento Humanizado:</strong> Nossa equipe está sempre
            pronta para oferecer suporte rápido e eficiente.
          </li>
          <li>
            <strong>Inovação Contínua:</strong> Investimos em tecnologias
            avançadas para atender às demandas crescentes do mercado.
          </li>
        </ul>

        <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
          Nossa Missão
        </h2>
        <p className="text-gray-700 text-sm md:text-lg lg:text-lg mb-4 leading-relaxed">
          Conectar pessoas e negócios em Moçambique, garantindo acesso a uma
          internet de qualidade, com um serviço transparente e acessível para
          todos.
        </p>

        <h2 className="text-md md:text-xl lg:text-xl font-bold text-blue-600 mb-4">
          Nossa Visão
        </h2>
        <p className="text-gray-700 text-sm md:text-lg lg:text-lg mb-4 leading-relaxed">
          Ser referência no setor de telecomunicações em Moçambique,
          impulsionando o progresso digital e promovendo a inclusão
          tecnológica.
        </p>

        <p className="text-gray-700 text-sm md:text-lg lg:text-lg mb-4 leading-relaxed">
          Na <strong>Eyazs Imperium</strong>, a sua conexão é a nossa
          prioridade. Seja para navegar, estudar, trabalhar ou crescer,
          estamos aqui para garantir que você esteja sempre ligado ao que
          importa.
        </p>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}
